import { ReactElement } from 'react';

import { ConfidentialAccessLevel, Practitioner } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { practitionerNameFormatter, Translate } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../translations';

type AuthorizerCellProps = {
   authorizer: Practitioner | undefined;
   grantee: Practitioner;
   accessLevel: ConfidentialAccessLevel;
};

export const AuthorizerCell = (props: AuthorizerCellProps): ReactElement | null => {
   const { authorizer, grantee, accessLevel } = props;

   if (!authorizer) {
      return null;
   }
   if (authorizer && authorizer.id.asNumber() === grantee.id.asNumber() && accessLevel === 'MONITORED') {
      return <Translate>{systemActivityTranslationKeys.system}</Translate>;
   }

   return <>{practitionerNameFormatter(authorizer)}</>;
};
